export enum CompanyType {
  Customer = 1,
  Supplier = 2,
  FreightAgent = 3,
  None = -1,
}
